import prepareValue from '@/util/prepareValue'

/**
 * Get field value to be send to the backend api
 *
 * Sometimes the way we store the object for v-model isn't the same as we want
 * to send to the backend. This property handles any data transformations that
 * we want to do before sending to the backend.
 * @type  {mixed}
 */
export default {
  computed: {
    payloadValue () {
      if (this.value && this.value.constructor === Array) {
        return this.value.map(function (value) {
          return prepareValue(value)
        })
      } else {
        return prepareValue(this.value)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend/mixins/payloadValue.js